<template>
  <CustomTitleBar :title="title" />
  <div class="page-content">
    <div class="pwd-input-wrap" v-if="!showConfirmInput">
      <div class="tip-text">请设置支付密码,用于支付验证</div>
      <!-- 密码输入框 -->
      <van-password-input :value="payPassword" :focused="showKeyboard" :length="6" @focus="showKeyboard = true" />
      <!-- 数字键盘 -->
      <van-number-keyboard v-model:show="showKeyboard" @input="onInput" @delete="onDelete" :maxlength="6"
        @blur="showKeyboard = false" />
    </div>
    <!-- 继续按钮 -->
    <div class="btn-wrap" v-if="!showConfirmInput">
      <van-button type="primary" round :disabled="payPassword.length !== 6" @click="showConfirmInput = true">
        继续
      </van-button>
    </div>
    <!-- 确认密码输入框 -->
    <div class="pwd-input-wrap" v-if="showConfirmInput">
      <div class="tip-text">请再次填写支付密码以确认</div>
      <van-password-input :value="confirmPassword" :focused="showConfirmKeyboard" :length="6"
        @focus="showConfirmKeyboard = true" />
      <van-number-keyboard v-model:show="showConfirmKeyboard" @input="onConfirmInput" @delete="onConfirmDelete"
        :maxlength="6" @blur="showConfirmKeyboard = false" />
    </div>
    <!-- 提交按钮 -->
    <div class="btn-wrap" v-if="showConfirmInput">
      <van-button type="primary" round :disabled="confirmPassword.length !== 6" @click="onSubmit">
        确认
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { showToast } from 'vant';
import { useRouter, useRoute } from 'vue-router';
import { realNameAuth } from '@/api/system';
import { useStore } from 'vuex';

const router = useRouter();
const route = useRoute();
const store = useStore();

const title = ref('设置支付密码')

const data = ref<any>(null);
const payPassword = ref('');
const confirmPassword = ref('');
const showKeyboard = ref(false);
const showConfirmKeyboard = ref(false);
const showConfirmInput = ref(false);

// 输入处理
const onInput = (key: string) => {
  if (payPassword.value.length < 6) {
    payPassword.value = payPassword.value + key;
  }
};

// 确认密码输入处理
const onConfirmInput = (key: string) => {
  if (confirmPassword.value.length < 6) {
    confirmPassword.value = confirmPassword.value + key;
  }
};

// 删除处理
const onDelete = () => {
  if (payPassword.value.length > 0) {
    payPassword.value = payPassword.value.slice(0, -1);
  }
};

// 确认密码删除处理
const onConfirmDelete = () => {
  if (confirmPassword.value.length > 0) {
    confirmPassword.value = confirmPassword.value.slice(0, -1);
  }
};

// 提交处理
const onSubmit = async () => {
  if (payPassword.value !== confirmPassword.value) {
    showToast({
      type: 'fail',
      message: '两次输入的密码不一致'
    });
    return;
  }

  try {
    // 这里添加设置支付密码的API调用
    await realNameAuth({
      idCard: data.value.idCard,
      payPassword: payPassword.value,
      phoneNumber: data.value.phoneNumber,
      realName: data.value.realName
    }).then(res => {
      console.log(res)
      if (res.code === 200) {
        showToast({
          type: 'success',
          message: '设置支付密码成功'
        });
        // 设置密码成功后，回到上一层，并刷新用户信息
        store.dispatch('user/refreshUserInfo');
        router.back();
      } else {
        showToast({
          type: 'fail',
          message: res.msg
        });
      }
    });

  } catch (error) {
    showToast({
      type: 'fail',
      message: '设置失败,请重试'
    });
  }
};

onMounted(() => {
  if (route.query.data) {
    data.value = JSON.parse(route.query.data as string)
    console.log(data.value)
  }
})
</script>

<style lang="scss" scoped>
.page-content {
  padding: 20px;

  .pwd-input-wrap {
    .tip-text {
      font-size: 14px;
      color: #666;
      margin-bottom: 20px;
      text-align: center;
    }

    // 修改密码输入框样式
    :deep(.van-password-input) {

      .van-password-input__security {
        justify-content: space-between;

        .van-password-input__item {
          width: 40px;
          height: 40px;
          background: #E5E5E5;
          border-radius: 8px;
          flex: none;
        }
      }
    }
  }

  .btn-wrap {
    margin-top: 40px;
    text-align: center;

    .van-button {
      width: 90%;
      background-color: $primary-color;
      border-color: $primary-color;
    }
  }
}
</style>